import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonicalUrl?: string;
  type?: string;
}

export function SEO({
  title = "League Life - Curated Connections for Athletes",
  description = "League Life brings trusted resources and curated experiences to athletes and their families. From vetted local services to wellness and social introductions, we make every move seamless.",
  keywords = "athlete lifestyle, sports professionals, curated experiences, trusted services, athlete concierge, sports family resources, athlete wellness, travel services, dining reservations, athlete connections",
  ogImage = "https://leaguelife.com/android-chrome-512x512.png",
  canonicalUrl = "https://leaguelife.com/",
  type = "website",
}: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
